import * as React from "react";
import { Text } from "@chakra-ui/react";
import { getFileType } from "../../../../api/common/fileinfo";

// Inline lime-on-lightLime extension pill. `size` lets the library picker
// render slightly tighter than the attached list, matching the design.
function FilePill({ fileInfo, type, size = 10 }) {
  const label = type ?? (fileInfo ? getFileType(fileInfo) : "");
  if (!label) return null;
  return (
    <Text
      as="span"
      display="inline-flex"
      alignItems="center"
      fontSize={`${size}px`}
      fontWeight="700"
      color="limeShade.600"
      bg="lightLime"
      px="7px"
      py="3px"
      borderRadius="5px"
      lineHeight="1.2"
      letterSpacing="0.04em"
    >
      {String(label).toUpperCase()}
    </Text>
  );
}

export default FilePill;
